import Axios from "axios";
import { useEffect, useReducer } from "react";
import { systemCode, xs_languageCode } from '..';
import { parseBetBuilderMatchBets } from "./parseBetBuilderMatchBets";
import { getConfiguration } from './utils/configuration';
import { dataFetchReducer } from "./utils/dataFetchReducer";

export function useFetchBetBuilderMatchBets(match, shouldExecute, reload, parseMatchData, frontendPageType) {
    const [state, dispatch] = useReducer(dataFetchReducer, {
        isLoading: true,
        isError: false,
    });
    
    useEffect(() => {
        if (!shouldExecute) {
            return;
        }
        
        let didCancel = false;

        const fetchData = async (url, params, callback) => {
            dispatch({ type: 'FETCH_INIT' });
            try {
                const result = await Axios.get(url, {params});
                if (!didCancel) {
                    callback(result.data);
                }
            } catch (error) {
                console.error('Errore ' + url + ': ' + error);
                if (!didCancel) {
                    dispatch({ type: 'FETCH_FAILURE' });
                }
            }
        };

        const url = getConfiguration().api.getBetBuilderEventBets;
        const params = {
            systemCode,
            lingua: xs_languageCode,
            hash: '',
            pal : match.pal,
            avv : match.avv
        }
        fetchData(url, params, function(response) {
            if (response == null || response === '') {
                dispatch({ type: 'FETCH_FAILURE' });
            }
            const betBuilderMatchBets = parseBetBuilderMatchBets(match, response, parseMatchData, frontendPageType);
            dispatch({ type: 'FETCH_SUCCESS', payload: betBuilderMatchBets });
        });
        
        return () => {
            didCancel = true;
        };
    }, [match, shouldExecute, reload]);

    return [state, dispatch];
}